import BaseAPI from './base'

/**
 * API xử lí luồng phòng học
 */

class StudentEventCalendarAPI extends BaseAPI {}

export default new StudentEventCalendarAPI('v1/student-event-calendar', 'StudentEventCalendar')
